/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LookupRecordingResponseExistingArtistsInnerMembersInner } from './LookupRecordingResponseExistingArtistsInnerMembersInner';
import {
    LookupRecordingResponseExistingArtistsInnerMembersInnerFromJSON,
    LookupRecordingResponseExistingArtistsInnerMembersInnerFromJSONTyped,
    LookupRecordingResponseExistingArtistsInnerMembersInnerToJSON,
} from './LookupRecordingResponseExistingArtistsInnerMembersInner';

/**
 * 
 * @export
 * @interface LookupRecordingResponseExistingArtistsInner
 */
export interface LookupRecordingResponseExistingArtistsInner {
    /**
     * 
     * @type {string}
     * @memberof LookupRecordingResponseExistingArtistsInner
     */
    stageName?: string;
    /**
     * 
     * @type {Array<LookupRecordingResponseExistingArtistsInnerMembersInner>}
     * @memberof LookupRecordingResponseExistingArtistsInner
     */
    members?: Array<LookupRecordingResponseExistingArtistsInnerMembersInner>;
    /**
     * fa (featuring, default), ofa (other featured) or nfa (non-featured)
     * @type {string}
     * @memberof LookupRecordingResponseExistingArtistsInner
     */
    featuredStatus?: LookupRecordingResponseExistingArtistsInnerFeaturedStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof LookupRecordingResponseExistingArtistsInner
     */
    sourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof LookupRecordingResponseExistingArtistsInner
     */
    source?: LookupRecordingResponseExistingArtistsInnerSourceEnum;
    /**
     * An existing artist to link, from the 4.4.1 lookup. Mutually exclusive with `source_id`.
     * @type {string}
     * @memberof LookupRecordingResponseExistingArtistsInner
     */
    artistId?: string;
}


/**
 * @export
 */
export const LookupRecordingResponseExistingArtistsInnerFeaturedStatusEnum = {
    Fa: 'fa',
    Ofa: 'ofa',
    Nfa: 'nfa'
} as const;
export type LookupRecordingResponseExistingArtistsInnerFeaturedStatusEnum = typeof LookupRecordingResponseExistingArtistsInnerFeaturedStatusEnum[keyof typeof LookupRecordingResponseExistingArtistsInnerFeaturedStatusEnum];

/**
 * @export
 */
export const LookupRecordingResponseExistingArtistsInnerSourceEnum = {
    Discogs: 'discogs',
    Musicbrainz: 'musicbrainz'
} as const;
export type LookupRecordingResponseExistingArtistsInnerSourceEnum = typeof LookupRecordingResponseExistingArtistsInnerSourceEnum[keyof typeof LookupRecordingResponseExistingArtistsInnerSourceEnum];


/**
 * Check if a given object implements the LookupRecordingResponseExistingArtistsInner interface.
 */
export function instanceOfLookupRecordingResponseExistingArtistsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LookupRecordingResponseExistingArtistsInnerFromJSON(json: any): LookupRecordingResponseExistingArtistsInner {
    return LookupRecordingResponseExistingArtistsInnerFromJSONTyped(json, false);
}

export function LookupRecordingResponseExistingArtistsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupRecordingResponseExistingArtistsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stageName': !exists(json, 'stageName') ? undefined : json['stageName'],
        'members': !exists(json, 'members') ? undefined : ((json['members'] as Array<any>).map(LookupRecordingResponseExistingArtistsInnerMembersInnerFromJSON)),
        'featuredStatus': !exists(json, 'featuredStatus') ? undefined : json['featuredStatus'],
        'sourceId': !exists(json, 'source_id') ? undefined : json['source_id'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'artistId': !exists(json, 'artist_id') ? undefined : json['artist_id'],
    };
}

export function LookupRecordingResponseExistingArtistsInnerToJSON(value?: LookupRecordingResponseExistingArtistsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stageName': value.stageName,
        'members': value.members === undefined ? undefined : ((value.members as Array<any>).map(LookupRecordingResponseExistingArtistsInnerMembersInnerToJSON)),
        'featuredStatus': value.featuredStatus,
        'source_id': value.sourceId,
        'source': value.source,
        'artist_id': value.artistId,
    };
}

